import {businessVI} from "./business/vi";

export const departmentVI = {
    "department": {
        "pageHeader": {
            "add": "Tạo mới phòng ban",
            "update": "Cập nhật phòng ban",
            "information": "Thông tin phòng ban",
            "department": "Phòng ban"

        },
        "row": {
            "department": "Phòng ban",
            "company": "Công ty",
            "branch": "Chi nhánh",
            "unit": "Đơn vị",

            "trashed": "Đã bị xóa",
            "pending": "Đang duyệt",
            "approved": "Đã duyệt"
        },

        "column": {
            "name": "Tên",
            "type": "Loại",
            "business": "Khối nghiệp vụ",
            "status": "Trạng thái"
        },
        "breadCrumb": {
            "title": "Danh sách phòng ban"
        },
        "header": {
            "create": "Tạo mới phòng ban",
            "update": "Cập nhật phòng ban"
        },
        "sider": {
            "label": "Quản lý phòng ban",
            "list": "Danh sách phòng ban",
            "import": "Import danh sách phòng ban",
            "export": "Export danh sách phòng ban",
            "create": "Tạo phòng ban",
            "update": "Cập nhật phòng ban"
        },
        "label": {
            "tax": "Mã số thuế",
            "name": "Tên",
            "business": "Khối nghiệp vụ",
            "code": "Mã",
            "address": "Địa chỉ",
            "parentId": "Đơn vị trực thuộc",
            "headOffice": "Trụ sở làm việc",
            "alias": "Tên viết tắt",
            "description": "Mô tả",
            "order": "Thứ tự",
            "type": "Loại"
        },
        "message": {
            "tax": "Vui lòng nhập mã số thuế",
            "name": "Vui lòng nhập tên",
            "business": "Vui lòng nhập khối nghiệp vụ",
            "code": "Vui lòng nhập mã",
            "address": "Vui lòng nhập địa chỉ",
            "headOffice": "Vui lòng nhập trụ sở làm việc",
            "parentId": "Vui lòng nhập đơn vị trực thuộc",
            "alias": "Vui lòng nhập tên viết tắt",
            "add": "Thêm mới phòng ban thành công",
            "update": "Cập nhật phòng ban thành công",
            "error": "Đã có lỗi xảy ra, vui lòng thử lại",
            "delete": "Xóa phòng ban thành công"
        },
        "placeholder": {
            "tax": "Nhập mã số thuế",
            "name": "Nhập tên",
            "business": "Nhập khối nghiệp vụ",
            "code": "Nhập mã code",
            "address": "Số..., quận,... thành phố",
            "headOffice": "Số..., quận,... thành phố",
            "parentId": "Nhập đơn vị trực thuộc",
            "alias": "Nhập tên viết tắt"
        },
        "table": {
            "name": "Tên",
            "typeName": "Loại",
            "business": "Khối nghiệp vụ"
        },
        "option": {
            "company": "Công ty",
            "branch": "Chi nhánh",
            "unit": "Đơn vị",
            "department": "Phòng ban"
        },
        "plusOutlined": {
            "business": "Tạo mới"
        },
    },
    ...businessVI

}
